function MovingStats({ items }) {
  const marqueeItems = [...items, ...items];

  return (
    <section className="moving-stats" aria-label="Studio highlights">
      <div className="moving-stats-track">
        {marqueeItems.map((item, index) => (
          <div className="moving-stat" key={`${item}-${index}`}>
            <span className="moving-stat-dot" aria-hidden="true" />
            <span>{item}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default MovingStats;
